<template>
  <div class="container text-left">
    <h4>
      Please answer the following to set up your profile:
    </h4>
    <div class="row">
      <div class="col col-2">
        <img src="../assets/icons8-health-book-48.png" />
      </div>
      <div class="col">
        Are you a Health Sciences student?
      </div>
    </div>
    <div class="row pb-3">
      <div class="col col-2">&nbsp;</div>
      <div class="col">
        <button
          type="button"
          class="btn"
          :class="{'btn-secondary': hsStudent === null || hsStudent === false, 'btn-primary': hsStudent === true}"
          @click="hsStudent = true"
        >
          Yes
        </button>
        <button
          type="button"
          class="btn ml-1"
          :class="{'btn-secondary': hsStudent  === null || hsStudent === true, 'btn-primary': hsStudent === false}"
          @click="hsStudent = false"
        >
          No
        </button>
      </div>
    </div>
    <div class="mx-auto pb-2">
      <button
        class="btn btn-primary"
        :disabled="!submitReady"
        @click="submit"
      >Submit</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileSetup',
  computed: {
    submitReady () {
      return (this.hsStudent !== null)
    }
  },
  data () {
    return {
      hsStudent: null
    }
  },
  methods: {
    submit () {
      var traits = []
      if (this.hsStudent) {
        traits.push('health')
      }
      this.$store.dispatch('saveProfile', traits)
      .then(()=> {
        this.$store.dispatch('fetchUserProfile')
      })
    }
  }
}
</script>
